<template>
  <div>
    <div class="header__top container">

        <router-link :to="{ name: 'home', params: { lang: this.$i18n.locale }}">
            <img src="~@/assets/images/softcare-logo-en.png" width="200px" class="logo responsive-image" v-if="this.$i18n.locale == 'en'"/>
            <img src="~@/assets/images/softcare-logo-ar.png" width="200px" class="logo responsive-image" v-if="this.$i18n.locale == 'ar'"/>
        </router-link>

        <div class="menu">

            <div class="nav-button hidden-lg" @click="toggleMegaMenu" v-bind:class="{ 'close-menu' : isVisibleMegaMenu }">
                <div class="hamburger">
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                </div>
            </div>

            <ul class="inline-list" v-bind:class="{ 'mega-menu-opened' : isVisibleMegaMenu }">

								<li>
                  <router-link :to="{ name: 'about', params: { lang: this.$i18n.locale }}">{{ $t("menu.aboutUs") }}</router-link>
                </li>

                <li>
                  <router-link :to="{ name: 'services', params: { lang: this.$i18n.locale }}">{{ $t("menu.services") }}</router-link>
                </li>

                <li>
                  <router-link :to="{ name: 'projects', params: { lang: this.$i18n.locale }}">{{ $t("menu.projects") }}</router-link>
                </li>

                <li>
                  <router-link :to="{ name: 'blog', params: { lang: this.$i18n.locale }}">{{ $t("menu.blog") }}</router-link>
                </li>

                <li>
                  <router-link :to="{ name: 'contact', params: { lang: this.$i18n.locale }}">{{ $t("menu.contactUs") }}</router-link>
                </li>

                <li>
                    <router-link :to="{ name: 'pricing', params: { lang: this.$i18n.locale }}">
                        <a class="button button--primary button--primary__small">
                            <span class="button--primary__text" exact>{{ $t("global.getAnEstimation") }}</span>
                        </a>
                    </router-link>
                </li>
            </ul>

            <a v-tooltip.bottom-center="toArabic" v-on:click.prevent="setLanguage('ar')" v-if="this.$i18n.locale == 'en'">
                <img src="~@/assets/images/lang-arabic.svg" width="30" alt="" class="responsive-image">
            </a>
            <a v-tooltip.bottom-center="toEnglish" v-on:click.prevent="setLanguage('en')" v-if="this.$i18n.locale == 'ar'">
                <img src="~@/assets/images/lang-english.svg" width="30" alt="" class="responsive-image">
            </a>

        </div>

    </div>

</div>
</template>

<script>
import Vue from "vue";
import VTooltip from "v-tooltip";
import VueLocalStorage from "vue-localstorage";

Vue.use(VTooltip);
Vue.use(VueLocalStorage);

export default {
	name: "MainHeader",
	props: ["preLoading"],
	data() {
		return {
			toArabic: "العربية",
			toEnglish: "English",
			isVisibleMegaMenu: false
		};
	},
	methods: {
		toggleMegaMenu: function(event) {
			this.isVisibleMegaMenu = !this.isVisibleMegaMenu;
		},
		closeMenu: function() {
			this.isVisibleMegaMenu = false;
		},
		setLanguage(lang) {
			this.$emit("update:preLoading", true);
			Vue.localStorage.set("userLang", lang);
			this.$route.params.lang = lang;
			this.$i18n.locale = lang;
			this.$validator.locale = lang;
			this.$validator.localize(lang);
			this.$router.push(
				{ force: true, name: this.$route.name, params: { lang: lang } },
				function() {
					location.reload();
				}
			);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/modules/MainHeader.vue